import React, { useEffect } from "react";
import { useWatch } from "react-hook-form";
import { findAgency, findAgencyLocal } from "../../misc/customOptions";
import { StyledInput } from "./styles";
import { InputTypes } from "./types";


export const Input = React.forwardRef( ({ inputRef, maxLength, control, watchField, disabled, name, value, type, placeholder, onBlur, onChange}: InputTypes, ref) =>  {
	const watchValue = useWatch({
		control,
		name: watchField? watchField: '',
		disabled: !watchField
	});

	useEffect(() => {
		if(name == "nomeAgenciaRelacionamento") {
			const agency = findAgency(watchValue);
			onChange(agency? agency.label : "");
		}

		if(name == "nomeLocalidadeAgRelacionamento") {
			const local = findAgencyLocal(watchValue);
			onChange(local? local.label : "");
		}
		
	}, [watchValue])

	return (
		<StyledInput
			ref = {inputRef}
			key={name}
			name={name}
			value={value}
			disabled={disabled ? disabled : false}
			type={type}
			placeholder={placeholder}
			onBlur={onBlur}
			onChange={(e) => {
				if (maxLength? e.target.value.length <= maxLength : true) {
					onChange(e.target.value);
				}
			}}/>
	)
})